const bedc = [
	'bedc:job:lookup',
	'bedc:job:lookup:{organizationId}/files',

	'bedc:job:search',

	'bedc:job:list',
	'bedc:job:list/allClients',
	'bedc:job:list:{organizationId}/allCustomers',
	'bedc:job:list:{organizationId}/targetAt',
	'bedc:job:list:{organizationId}/dueAt',
	'bedc:job:list:{organizationId}/assignedTo',
	'bedc:job:list:{organizationId}/salesPerson',
	'bedc:job:list:{organizationId}/timeInStatusFrom',
	'bedc:job:list:{organizationId}/folder/bedc:cat:chat',
	'bedc:job:list:{organizationId}/folder/bedc:cat:in-progress',

	'bedc:job:read',
	'bedc:job:read:{organizationId}/timeSpent',
	'bedc:job:read:{organizationId}/jrf',
	'bedc:job:read:{organizationId}/hitl',
	'bedc:job:read:{organizationId}/hitl/v2',
	'bedc:job:read:{organizationId}/hitl/v2/client-hitl',
	'bedc:job:read:{organizationId}/hitl/v2/polygon-drawing',
	'bedc:job:read:{organizationId}/trussHitl',
	'bedc:job:read:{organizationId}/team',
	'bedc:job:read:{organizationId}/salesPerson',
	'bedc:job:read:{organizationId}/customerContact',
	'bedc:job:read:{organizationId}/previewFiles',
	'bedc:job:read:{organizationId}/targetAt',
	'bedc:job:read:{organizationId}/bidAt',
	'bedc:job:read:{organizationId}/dueAt',
	'bedc:job:read:{organizationId}/deliveryRequestedAt',
	'bedc:job:read:{organizationId}/deliveryScheduledAt',
	'bedc:job:read:{organizationId}/siteAddress',
	'bedc:job:read:{organizationId}/files',
	'bedc:job:read:{organizationId}/file/bedc:cat:chat',
	'bedc:job:read:{organizationId}/folders',
	'bedc:job:read:{organizationId}/folder/bedc:cat:chat',
	'bedc:job:read:{organizationId}/folder/bedc:cat:in-progress',
	'bedc:job:read:{organizationId}/folder/bedc:cat:saas-accounting',
	'bedc:job:read:{organizationId}/folder/bedc:cat:saas-estimator',
	'bedc:job:read:{organizationId}/folder/bedc:cat:saas-only',
	'bedc:job:read:{organizationId}/chat/announcement',
	'bedc:job:read:{organizationId}/form/difficulty',
	'bedc:job:read:{organizationId}/form/difficulty-org',
	'bedc:job:read:{organizationId}/form/costings',
	'bedc:job:read:{organizationId}/form/fps',
	'bedc:job:read:{organizationId}/form/fps/byFeatureFlag/client-fps',
	'bedc:job:read:{organizationId}/activityLog',
	'bedc:job:read:{organizationId}/activityLog/category:admin',
	'bedc:job:read:{organizationId}/activityLog/category:internal',
	'bedc:job:read:{organizationId}/activityLog/category:client',
	//
	'bedc:job:read:{organizationId}/stages',
	'bedc:job:read:{organizationId}/activeStages',
	'bedc:job:read:{organizationId}/stage/draft',
	'bedc:job:read:{organizationId}/stage/preprocess',
	'bedc:job:read:{organizationId}/stage/preprocess/client-hitl',
	'bedc:job:read:{organizationId}/stage/fps',
	'bedc:job:read:{organizationId}/stage/fps/byFeatureFlag/client-fps',
	'bedc:job:read:{organizationId}/stage/jrf',
	'bedc:job:read:{organizationId}/stage/jrf/debug',
	'bedc:job:read:{organizationId}/stage/hitl',
	'bedc:job:read:{organizationId}/stage/hitl/v2',
	'bedc:job:read:{organizationId}/stage/hitl/v2/client-hitl',
	'bedc:job:read:{organizationId}/stage/hitl/debug',
	'bedc:job:read:{organizationId}/stage/trussHitl',
	'bedc:job:read:{organizationId}/stage/aiFrame',
	'bedc:job:read:{organizationId}/stage/aiFrame/client-hitl',
	'bedc:job:read:{organizationId}/stage/wholeHouse',
	'bedc:job:read:{organizationId}/stage/design',
	'bedc:job:read:{organizationId}/stage/designSimple',
	'bedc:job:read:{organizationId}/stage/fileProcessing',
	'bedc:job:read:{organizationId}/stage/sealing',
	'bedc:job:read:{organizationId}/stage/pricing',
	'bedc:job:read:{organizationId}/stage/estimateManagement',
	'bedc:job:read:{organizationId}/stage/accountingReview',
	'bedc:job:read:{organizationId}/stage/invoicing',
	'bedc:job:read:{organizationId}/stage/delivery',
	'bedc:job:read:{organizationId}/stage/orderManagement',
	'bedc:job:read:{organizationId}/stage/production',
	'bedc:job:read:{organizationId}/stage/staging',
	'bedc:job:read:{organizationId}/stage/managementReview',
	'bedc:job:read:{organizationId}/integration/link',

	'bedc:job:create',
	'bedc:job:create:{organizationId}/file',
	'bedc:job:create:{organizationId}/file/bedc:category:completed',
	'bedc:job:create:{organizationId}/folder',

	'bedc:job:update:{organizationId}/allocateAll',
	'bedc:job:update:{organizationId}/cancel',
	'bedc:job:update:{organizationId}/cancel/inProgress',
	'bedc:job:update:{organizationId}/hold',
	'bedc:job:update:{organizationId}/duplicate',
	'bedc:job:update:{organizationId}/duplicate/estimate-to-order',
	'bedc:job:update:{organizationId}/removeHold',
	'bedc:job:update:{organizationId}/salesPerson',
	'bedc:job:update:{organizationId}/customerContact',
	'bedc:job:update:{organizationId}/jrf',
	'bedc:job:update:{organizationId}/hitl',
	'bedc:job:update:{organizationId}/hitl/v2',
	'bedc:job:update:{organizationId}/hitl/v2/client-hitl',
	'bedc:job:update:{organizationId}/hitl/v2/polygon-drawing',
	'bedc:job:update:{organizationId}/trussHitl',
	'bedc:job:update:{organizationId}/targetAt',
	'bedc:job:update:{organizationId}/bidAt',
	'bedc:job:update:{organizationId}/dueAt',
	'bedc:job:update:{organizationId}/deliveryRequestedAt',
	'bedc:job:update:{organizationId}/deliveryScheduledAt',
	'bedc:job:update:{organizationId}/siteAddress',
	'bedc:job:update:{organizationId}/chat/announcement',
	'bedc:job:update:{organizationId}/form/details',
	'bedc:job:update:{organizationId}/form/details/jobType',
	'bedc:job:update:{organizationId}/form/details/requestType',
	'bedc:job:update:{organizationId}/form/difficulty',
	'bedc:job:update:{organizationId}/form/difficulty/complete',
	'bedc:job:update:{organizationId}/form/difficulty-org',
	'bedc:job:update:{organizationId}/form/costings',
	'bedc:job:update:{organizationId}/file/archive',
	'bedc:job:update:{organizationId}/file/label',
	'bedc:job:update:{organizationId}/file/parentFolderId',
	'bedc:job:update:{organizationId}/file/version',
	'bedc:job:update:{organizationId}/folder/name',
	'bedc:job:update:{organizationId}/folder/parentFolderId',
	'bedc:job:update:{organizationId}/integration/link',
	//
	'bedc:job:update:{organizationId}/assignee',
	'bedc:job:update:{organizationId}/status',
	'bedc:job:update:{organizationId}/timer/start',
	'bedc:job:update:{organizationId}/timer/pause',
	'bedc:job:update:{organizationId}/stage/preprocess',
	'bedc:job:update:{organizationId}/stage/fps',
	'bedc:job:update:{organizationId}/stage/jrf',
	'bedc:job:update:{organizationId}/stage/hitl',
	'bedc:job:update:{organizationId}/stage/trussHitl',
	'bedc:job:update:{organizationId}/stage/aiFrame',
	'bedc:job:update:{organizationId}/stage/wholeHouse',
	'bedc:job:update:{organizationId}/stage/sealing',
	'bedc:job:update:{organizationId}/stage/pricing',
	'bedc:job:update:{organizationId}/stage/estimateManagement',
	'bedc:job:update:{organizationId}/stage/accountingReview',
	'bedc:job:update:{organizationId}/stage/invoicing',
	'bedc:job:update:{organizationId}/stage/delivery',
	'bedc:job:update:{organizationId}/stage/orderManagement',
	'bedc:job:update:{organizationId}/stage/production',
	'bedc:job:update:{organizationId}/stage/staging',
	'bedc:job:update:{organizationId}/stage/managementReview',

	'bedc:job:bulkupdate/timer',

	'bedc:job:delete:{organizationId}',
	'bedc:job:delete:{organizationId}/inProgress',
	'bedc:job:delete:{organizationId}/file/finalised-job',
	'bedc:job:delete:{organizationId}/file/draft-job',
	'bedc:job:delete:{organizationId}/file/supplied-files',
	'bedc:job:delete:{organizationId}/folder',
] as const;

const integration = [
	'integration:job:create',
	'integration:job:read',
	'integration:job:delete',

	'integration:job:read:{organizationId}/file',
] as const;

export default [...bedc, ...integration] as const;
